import { render, staticRenderFns } from "./TYKSList.vue?vue&type=template&id=74b5c18c&scoped=true"
import script from "./TYKSList.vue?vue&type=script&lang=js"
export * from "./TYKSList.vue?vue&type=script&lang=js"
import style0 from "./TYKSList.vue?vue&type=style&index=0&id=74b5c18c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b5c18c",
  null
  
)

export default component.exports